import { NATIVE_TITLE_SIZE, v2Text } from '@flows/configs/petHealthV2/steps/elements/shared'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { ElementFragment } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import { BaseSchema_PetHealthV2GetsafeDe } from '@flows/insurance/schemas'

export const petNameElements = (params: StepConfigParams) =>
  ({
    elements: [
      { type: 'title', text: v2Text('steps.pet_name.title'), size: NATIVE_TITLE_SIZE },
      {
        type: 'input',
        shouldTrackValues: true,
        label: v2Text('steps.pet_name.label'),
        name: params.helperFunctions.getParamPath('pet_name'),
      },
    ],
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_name')]:
        BaseSchema_PetHealthV2GetsafeDe.shape.pet_name.unwrap(),
    }),
  }) as const satisfies ElementFragment
